import styled from "styled-components";
import { useAppContext } from "../../../contexts/Context";
import { useRef } from "react";
import generatePDF from "react-to-pdf";
import { TheDate } from "../../../constants/thedate";
export default function SeniorThird(props) {
  const resultRef = useRef();
  if (!props.owner) return null;
  const { results } = props;
  const { owner } = props;
  const { session } = props;
  const { teacher } = props;

  const getClass = (user) => {
    switch (props.historicalClass || user?.currentClass) {
      case "FGJSC_001":
        return "JSS 1";
        break;
      case "FGJSC_002":
        return "JSS 2";
        break;
      case "FGJSC_003":
        return "JSS 3";
        break;
      case "FGSSC_001":
        return "SSS 1";
        break;
      case "FGSSC_002":
        return "SSS 2";
        break;
      case "FGSSC_003":
        return "SSS 3";
        break;
      case "FGBSC_001":
        return "Basic 1";
        break;
      case "FGBSC_002":
        return "Basic 2";
        break;
      case "FGBSC_003":
        return "Basic 3";
        break;
      case "FGBSC_004":
        return "Basic 4";
        break;
      case "FGBSC_005":
        return "Basic 5";
        break;
      case "FGKGC_001":
        return "K.G 1";
        break;
      case "FGKGC_003":
        return "K.G 2";
        break;
      case "FGNSC_001":
        return "Nursery 1";
        break;
      case "FGNSC_002":
        return "Nursery 2";
        break;
      default:
        return "None"; // Provide a default value if none of the cases match
    }
  };

  return (
    <div className="d-flex flex-column gap-5">
      <div className="download-field d-flex flex-row px-5">
        <button
          className=""
          onClick={() =>
            generatePDF(resultRef, {
              filename:
                props.owner.firstName +
                props.owner.admissionNumber +
                "Third-Term",
            })
          }
        >
          download
        </button>
      </div>
      <ResultDiv className="d-flex flex-column p-3 pb-0" ref={resultRef}>
        <img src="/images/result-header.png" className="logo-container" />
        <div className="intro-div d-flex flex-column">
          <div className="d-flex flex-row intro-header mt-1 align-items-center justify-content-between p-2">
            <div className="title">
              <p>Academic Year</p>
              <p className="academic-year">
                {props.session}/{Number(props.session) + 1}
              </p>
            </div>
            <div className="">
              <h6>THIRD TERM RESULT</h6>
            </div>
            <div className="title">
              <p>Admission Number</p>
              <p className="academic-year">{props.owner.admissionNumber}</p>
            </div>
          </div>
          <div className="d-flex flex-row intro-header  align-items-center justify-content-between p-2">
            <div className="title w-75 d-flex flex-row">
              <p className="" style={{ width: "10%" }}>
                Name
              </p>
              <p className="student-name" style={{ width: "80%" }}>
                {props.owner.lastName} {props.owner.firstName}{" "}
                {props.owner.middleName}
              </p>
            </div>
            <div className="title w-25 d-flex flex-row">
              <p style={{ width: "30%" }}>Class</p>
              <p className="student-name" style={{ width: "50%" }}>
                {getClass(props.owner)}
              </p>
            </div>
            {/* <div className="item">{resultsData ? resultsData[0][0] : ""}</div> */}
          </div>
          <div className="results-div d-flex flex-row">
            <div className="performance-div p-2 d-flex flex-column gap-1">
              <table className="results-table table table-bordeerd mb-0">
                <thead>
                  <tr>
                    <th className="holder"></th>
                    <th>
                      <p className="rotate">C.A Scores</p>
                    </th>
                    <th>
                      <p className="rotate">Exam Scores</p>
                    </th>
                    <th>
                      <p className="rotate">Third Term Total</p>
                    </th>
                    <th>
                      <p className="rotate">Second Term Total</p>
                    </th>
                    <th>
                      <p className="rotate">First Term Total</p>
                    </th>
                    <th>
                      <p className="rotate">Total Scores</p>
                    </th>
                    <th>
                      <p className="rotate">Average Scores</p>
                    </th>
                    <th>
                      <p className="rotate">Grade</p>
                    </th>
                    <th>
                      <p className="holder text-center">Comments</p>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Max. Obtainable</td>
                    <th>40</th>
                    <th>60</th>
                    <th>100</th>
                    <th>100</th>
                    <th>100</th>
                    <th>300</th>
                  </tr>
                  <tr>
                    <td>English Language</td>
                    {props.results?.slice(1, 10).map((score) => (
                      <td className="text-center">{score}</td>
                    ))}
                  </tr>
                  <tr>
                    <td>Mathematics</td>
                    {props.results?.slice(10, 19).map((score) => (
                      <td className="text-center">{score}</td>
                    ))}
                  </tr>
                  <tr>
                    <td>Biology</td>
                    {props.results?.slice(19, 28).map((score) => (
                      <td className="text-center">{score}</td>
                    ))}
                  </tr>
                  <tr>
                    <td>Physics</td>
                    {props.results?.slice(28, 37).map((score) => (
                      <td className="text-center">{score}</td>
                    ))}
                  </tr>
                  <tr>
                    <td>Chemistry</td>
                    {props.results?.slice(37, 46).map((score) => (
                      <td className="text-center">{score}</td>
                    ))}
                  </tr>
                  <tr>
                    <td>Further Mathematics</td>
                    {props.results?.slice(46, 55).map((score) => (
                      <td className="text-center">{score}</td>
                    ))}
                  </tr>
                  <tr>
                    <td>Yoruba Language</td>
                    {props.results?.slice(55, 64).map((score) => (
                      <td className="text-center">{score}</td>
                    ))}
                  </tr>
                  <tr>
                    <td>Civic Education</td>
                    {props.results?.slice(64, 73).map((score) => (
                      <td className="text-center">{score}</td>
                    ))}
                  </tr>
                  <tr>
                    <td>Computer Studies</td>
                    {props.results?.slice(73, 82).map((score) => (
                      <td className="text-center">{score}</td>
                    ))}
                  </tr>
                  <tr>
                    <td>Data Processing</td>
                    {props.results?.slice(82, 91).map((score) => (
                      <td className="text-center">{score}</td>
                    ))}
                  </tr>
                  <tr>
                    <td>I.R.S</td>
                    {props.results?.slice(91, 100).map((score) => (
                      <td className="text-center">{score}</td>
                    ))}
                  </tr>
                  <tr>
                    <td>Arabic</td>
                    {props.results?.slice(100, 109).map((score) => (
                      <td className="text-center">{score}</td>
                    ))}
                  </tr>
                  <tr>
                    <td>Economics</td>
                    {props.results?.slice(109, 118).map((score) => (
                      <td className="text-center">{score}</td>
                    ))}
                  </tr>
                  <tr>
                    <td>Government</td>
                    {props.results?.slice(118, 127).map((score) => (
                      <td className="text-center">{score}</td>
                    ))}
                  </tr>
                  <tr>
                    <td>Geography</td>
                    {props.results?.slice(127, 136).map((score) => (
                      <td className="text-center">{score}</td>
                    ))}
                  </tr>
                  <tr>
                    <td>Agricultural Science</td>
                    {props.results?.slice(136, 145).map((score) => (
                      <td className="text-center">{score}</td>
                    ))}
                  </tr>
                  <tr>
                    <td>Literature in English</td>
                    {props.results?.slice(145, 154).map((score) => (
                      <td className="text-center">{score}</td>
                    ))}
                  </tr>
                  <tr>
                    <td>Financial Accounting</td>
                    {props.results?.slice(154, 163).map((score) => (
                      <td className="text-center">{score}</td>
                    ))}
                  </tr>
                  <tr>
                    <td>Commerce</td>
                    {props.results?.slice(163, 172).map((score) => (
                      <td className="text-center">{score}</td>
                    ))}
                  </tr>
                  <tr>
                    <td>QURAN</td>
                    {props.results?.slice(172, 181).map((score) => (
                      <td className="text-center">{score}</td>
                    ))}
                  </tr>
                </tbody>
              </table>
              <div className="d-flex flex-column">
                <div className="header d-flex flex-row align-items-center mb-1  ">
                  <h6>2</h6>{" "}
                  <h6>PHYSICAL DEVELOPMENT, HEALTH AND CLEANLINESS</h6>
                </div>
                <table
                  className="table table-bordered mb-0"
                  border="1"
                  width="100%"
                >
                  <thead>
                    <tr>
                      <th colSpan={2}>Height</th>
                      <th colSpan={2}>Weight</th>
                      <th>No. of Times Absent Due to Illness</th>
                      <th>Nature of Illness</th>
                    </tr>
                    <tr>
                      <td className="no-bottom">Beginning of Term</td>
                      <td className="no-bottom">End of Term</td>
                      <td className="no-bottom">Beginning of Term</td>
                      <td className="no-bottom">End of Term</td>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      {props.results?.slice(194, 200).map((score) => (
                        <td className="text-center">{score}</td>
                      ))}
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="d-flex flex-column gap-1">
                <div className="header d-flex flex-row align-items-center mb-1  ">
                  <h6>3</h6> <h6>CLUBS, YOUTH ORGANIZATION ETC</h6>
                </div>
                <table
                  className="table table-bordered mb-0"
                  border="1"
                  width="100%"
                >
                  <thead>
                    <tr>
                      <th>Organisation</th>
                      <th>
                        <p>Office Held</p>
                      </th>
                      <th>
                        <p>Significant Contibution</p>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="last">
                      {props.results?.slice(205, 208).map((score) => (
                        <td className="text-center">{score}</td>
                      ))}
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="d-flex flex-column gap-1">
                <div className="header d-flex flex-row align-items-center mb-1  ">
                  <h6>4</h6> <h6>SPORTS</h6>
                </div>
                <table
                  className="table table-bordered mb-0"
                  border="1"
                  width="100%"
                >
                  <thead>
                    <tr>
                      <th>Events</th>
                      <th>Ball Games</th>
                      <th>Track</th>
                      <th>Throws</th>
                      <th>Swimming</th>
                      <th>Jumps</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Level Attained</td>
                      {props.results?.slice(200, 205).map((score) => (
                        <td className="text-center">{score}</td>
                      ))}
                    </tr>
                    <tr>
                      <td className="special-td"></td>
                      <td className="special-td">A-Excellent</td>
                      <td className="special-td">B-Very Good</td>
                      <td className="special-td">C-Good</td>
                      <td className="special-td">D-Fair</td>
                      <td className="special-td">E-Poor</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="activity-div d-flex flex-column justify-content-between p-2">
              <table className="mb-0">
                <thead>
                  <tr>
                    <th colSpan={3}>ATTENDANCE (Regularity and Punctuality)</th>
                  </tr>
                  <tr>
                    <th>Times school opened</th>
                    <th>Times present</th>
                    <th>Times absent</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    {props.results?.slice(215, 218).map((score) => (
                      <td className="text-center">{score}</td>
                    ))}
                  </tr>
                </tbody>
              </table>
              {/* <table className="w-100">
        <thead>
            <tr>
                <th colSpan={2}>PERSONAL TRAIT</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Punctuality</td>
                <td>honesty</td>
            </tr>
        </tbody>
       </table> */}
              <table className="w-100 table psycho">
                <thead>
                  <tr>
                    <th>PSYCHOMOTOR/PERSONAL SKILLS</th>
                  </tr>
                </thead>
                <tbody>
                  {/* <tr className="">
                    <p className="d-flex justify-content-between ">
                      <p>Literary</p>
                      <p className="">
                        {props.results ? props.results[218] : ""}
                      </p>
                    </p>
                  </tr> */}
                  {/* <tr>
                    <p className="d-flex justify-content-between">
                      <p>Quran memorisation</p>
                      <p className="">
                        {props.results ? props.results[219] : ""}
                      </p>
                    </p>
                  </tr> */}
                  <tr>
                    <p className="d-flex justify-content-between w-100">
                      <p>Technical</p>
                      <p className="">
                        {props.results ? props.results[220] : ""}
                      </p>
                    </p>
                    {/* <p className="d-flex justify-content-between w-100">
                      <p>Technical</p>
                      <p className="">
                        {props.results ? props.results[221] : ""}
                      </p>
                    </p> */}
                  </tr>
                  <tr>
                    <p className="d-flex justify-content-between w-100">
                      <p>Innovative</p>
                      <p className="">
                        {props.results ? props.results[222] : ""}
                      </p>
                    </p>{" "}
                    {/* <p className="d-flex justify-content-between w-100">
                      <p>Arabiyya/Fighu</p>
                      <p className="">
                        {props.results ? props.results[223] : ""}
                      </p>
                    </p> */}
                  </tr>
                  <tr>
                    <p className="d-flex justify-content-between w-100">
                      <p>Sporting</p>
                      <p className="">
                        {props.results ? props.results[224] : ""}
                      </p>
                    </p>{" "}
                    <p className="d-flex justify-content-between w-100">
                      <p>Cultural</p>
                      <p className="">
                        {props.results ? props.results[225] : ""}
                      </p>
                    </p>
                  </tr>
                </tbody>
              </table>
              <div className="affective-div">
                <div>
                  <p className="th">AFFECTIVE DOMAIN</p>
                </div>
                <div className="d-flex flex-column affective-body">
                  <div className="d-flex flex-row justify-content-between items">
                    <p className="td">Punctuality</p>
                    <p className="td">
                      {props.results ? props.results[226] : ""}{" "}
                    </p>
                  </div>
                  <div className="d-flex flex-row justify-content-between items">
                    <p className="td">Politeness</p>
                    <p className="td">
                      {props.results ? props.results[227] : ""}{" "}
                    </p>
                  </div>
                  <div className="d-flex flex-row justify-content-between items">
                    <p className="td">Attentiveness</p>
                    <p className="td">
                      {props.results ? props.results[228] : ""}{" "}
                    </p>
                  </div>
                  <div className="d-flex flex-row justify-content-between items">
                    <p className="td">Neatness</p>
                    <p className="td">
                      {props.results ? props.results[229] : ""}{" "}
                    </p>
                  </div>
                  <div className="d-flex flex-row justify-content-between items">
                    <p className="td">Initiative</p>
                    <p className="td">
                      {props.results ? props.results[230] : ""}{" "}
                    </p>
                  </div>
                  {/* <div className="d-flex flex-row justify-content-between items">
                    <p className="td">Perseverance</p>
                    <p className="td">
                      {props.results ? props.results[231] : ""}{" "}
                    </p>
                  </div> */}
                  <div className="d-flex flex-row justify-content-between items">
                    <p className="td">Team Work</p>
                    <p className="td">
                      {props.results ? props.results[232] : ""}{" "}
                    </p>
                  </div>
                  <div className="d-flex flex-row justify-content-between items">
                    <p className="td">Leadership Spirit</p>
                    <p className="td">
                      {props.results ? props.results[233] : ""}{" "}
                    </p>
                  </div>
                  <div className="d-flex flex-row justify-content-between items">
                    <p className="td">Relationship with Teachers</p>
                    <p className="td">
                      {props.results ? props.results[234] : ""}{" "}
                    </p>
                  </div>
                  {/* <div className="d-flex flex-row justify-content-between items">
                    <p className="td">Attitude to Work</p>
                    <p className="td">
                      {props.results ? props.results[235] : ""}{" "}
                    </p>
                  </div> */}
                  <div className="d-flex flex-row justify-content-between items">
                    <p className="td">Health</p>
                    <p className="td">
                      {props.results ? props.results[226] : ""}{" "}
                    </p>
                  </div>
                  {/* <div className="d-flex flex-row justify-content-between items">
                    <p className="td">Emotional Stability</p>
                    <p className="td">
                      {props.results ? props.results[227] : ""}{" "}
                    </p>
                  </div> */}
                  {/* <div className="d-flex flex-row justify-content-between items">
                    <p className="td">Inovative</p>
                    <p className="td">
                      {props.results ? props.results[228] : ""}{" "}
                    </p>
                  </div> */}
                </div>
              </div>
              <div className="scales-div d-flex flex-column gap-1">
                <div className="">
                  <p className="header-text">SCALES</p>
                </div>
                <div className="d-flex flex-row flex-wrap gap-2 align-items-center">
                  <p className="td mb-0">
                    <span>5</span> - Excellent
                  </p>
                  <p className="td mb-0">
                    <span>4</span> - Good
                  </p>
                  <p className="td mb-0">
                    <span>3</span> - Fair
                  </p>
                  <p className="td mb-0">
                    <span>2</span> - Poor
                  </p>
                  <p className="td mb-0">
                    <span>1</span> - No trait
                  </p>
                </div>
              </div>
              <table className="marks-table">
                <thead>
                  <tr>
                    <th>Total Marks Obtainable</th>
                    <th>Total Marks Obtained</th>
                    <th>Percantage</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ height: "50px" }}>
                    {props.results?.slice(210, 213).map((score) => (
                      <td className="text-center academic-year">{score}</td>
                    ))}
                  </tr>
                </tbody>
              </table>
              <div className="d-flex flex-column gap-2 senior-stamp">
                <div className="d-flex flex-row gap-1 border flex-wrap td">
                  <p>House Master's Comments:</p>
                  <p className="comments reopens">
                    {props.results ? props.results[214] : ""}
                  </p>
                </div>

                <div className="d-flex flex-row border gap-1 flex-wrap td">
                  <p>Class Teacher's Comments:</p>
                  <p className="comments reopens">
                    {props.results ? props.results[192] : ""}{" "}
                  </p>
                  <div className="d-flex flex-row gap-2 td">
                    <p>Date:</p>
                    <p className="comments reopens">
                      {props.datePublished || TheDate()}
                    </p>
                    {/* <p className="comments">
                      <img
                        src={props.teacher.teacherSignature}
                        className="signature-img"
                      />
                    </p> */}
                  </div>
                </div>

                <div className="d-flex flex-row border gap-1 flex-wrap td">
                  <p>Principal's Comments:</p>
                  <p className="comments reopens">
                    {props.results ? props.results[193] : ""}{" "}
                  </p>
                </div>
                <div className="d-flex flex-row gap-2 td">
                  <p>School Reopens: </p>
                  <p className="comments reopens">
                    {props.results ? props.results[191] : ""}{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ResultDiv>
    </div>
  );
}
const ResultDiv = styled.div`
  width: 1000px;
  margin: auto;
  height: fit-content !important;
  background-color: white;
  font-weight: 400;
  .psycho {
    .d-flex {
      font-size: 13px;
      margin-bottom: 0 !important;
      padding: 3px 5px !important;
      border-bottom: 1px solid black;
    }
  }
  .last {
    height: 27px;
  }
  .results-table {
    td {
      text-transform: capitalize !important;
    }
  }
  .intro-header {
    border: 1px solid black;
    height: 40px;
    font-size: 13px !important;
    border-bottom: 0 !important;
    .student-name {
      border-bottom: 1px solid black;
    }
  }
  .header {
    gap: 50px;
    margin-bottom: 0 !important;
  }
  .header h6 {
    font-size: 13px !important;
  }
  .comments {
    text-decoration: underline !important;
  }
  span {
    font-weight: 600;
  }
  .no-bottom {
    border-bottom: 0 !important;
  }
  .items {
    border-bottom: 1px solid black;
    border-collapse: collapse;
  }
  .logo-div {
    height: 180px;
  }
  .affective-body {
    border-right: 1px solid black;
    border-left: 1px solid black;
    .d-flex {
      font-size: 14px;
      margin-bottom: 0 !important;
      padding: 3px 5px !important;
    }
  }
  .results-div {
    border: 1px solid black;
  }
  .performance-div {
    width: 70%;
    border-right: 1px solid black;
  }
  .activity-div {
    width: 30%;
  }
  .table {
    border-collapse: collapse !important;
    border: 1px solid black;
  }
  tr,
  td,
  tr,
  thead,
  tbody {
    border-collapse: collapse !important;
  }
  td {
    border: 1px solid black;
    white-space: nowrap;
    padding: 3px;
  }

  th,
  .th {
    font-weight: 500;
    text-align: center;
    text-transform: capitalize;
    font-size: 13px;
    border: 1px solid black !important;
  }
  .header-text {
    font-weight: 500;
    text-align: start;
    text-transform: capitalize;
    font-size: 13px;
  }
  h6 {
    font-weight: 600 !important;
  }
  td,
  .td {
    font-size: 13px;
  }
  p,
  h3,
  h6 {
    margin: 0 !important;
  }
  .results-table {
    border-collapse: collapse;
    thead {
      height: 140px !important;
    }
    th {
      text-align: center;
      white-space: nowrap;
      padding: 3px;
      .rotate {
        transform: rotate(-90deg);
        text-align: center !important;
        width: 20px;
        margin-top: -40px !important;
      }
    }
    .holder {
      width: auto !important;
    }
  }
  .special-td {
    border-right: 0 !important;
    border-left: 0 !important;
  }
`;
